import React from 'react';
import Check from './check';
import X from './x';
import TvChannelListPackage from './tvChannelListPackage';
import TranslationService from "../../service/TranslationService";
import {CHANNELS, CHANNELS_LIST} from "../../language-content/keys";

const tvChannelsList = (props) => {
    const selectedTariffType = props.selectedTariffType && props.tariffTypes.length > 0 &&
        props.tariffTypes.find(tt => tt.tariffType.id == props.selectedTariffType);

    const tariffModels = selectedTariffType && selectedTariffType.tariffModels;

    if (!tariffModels || !props.channels || props.channels.length === 0 )
        return null;

    const colSizes = calculateChannelColSize(tariffModels.length + 1);


    return (
        <section id="channels-list" className="bg-gray-15 py-5 no-packages">
            <div className="container">
                <div className="row">
                    <div className="col-12 d-flex align-items-center mb-4" id="showChannels"><h3
                        className="serif-bold mb-0 mr-3">{TranslationService.translate(CHANNELS_LIST, props.lang)}:</h3>

                    </div>

                    <div className={`col-12 shownTable ${props.showChannels ? '' : 'closed'}`}>
                        <div className="bg-white p-4">
                            <div className="table-responsive">
                                <table className="table table-fixed text-center">
                                    <thead>
                                    {displayTariffModels(tariffModels)}
                                    </thead>
                                    <tbody id="table-scroll">
                                    {displayTvChannels()}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );

    function displayTariffModels(tariffModels) {
        return (
            <tr>
                <th scope="col" className={`col-${colSizes[0]} fake-thead`}> {TranslationService.translate(CHANNELS, props.lang)} </th>
                {tariffModels.map((tm, index) => {
                    return (
                        <th scope="col" className={`col-${colSizes[index + 1]}`}>
                            {props.tariffModelShortNames && props.tariffModelShortNames[tm.id] ? props.tariffModelShortNames[tm.id] : tm.name}
                        </th>
                    )
                })}
            </tr>
        )
    }

    function displayTvChannels() {
        return props.channels.map(c => {
            return (
                <tr>
                    <th scope="row" class={`col-${colSizes[0]}`}>
                        <img
                            src={c.channel.channelLogoPath} alt=""
                            className="img-fluid d-inline-block"/>
                        <div> {displayChannelName(c.channel)} </div>
                    </th>

                    {tariffModels.map((tm, index) => {
                        return (
                            <td className={`col-${colSizes[index + 1]}`}>
                                {displayTvChannelTariffModelStatus(c, tm)}
                            </td>
                        )
                    })}
                </tr>
            )
        })
    }

    function displayTvChannelTariffModelStatus(channelDto, tariffModel) {
        const instances = channelDto.packageInstances.filter(pi => pi.tariffModel.id == tariffModel.id)
        if (instances.length > 0) {
            if (instances.map(i => i.packageType.toLowerCase()).includes('included')) {
                return <Check/>
            } else {
                const nonIncludedInstance = instances.filter(i => !['default', 'included'].includes(i.packageType.toLowerCase()))
                if(nonIncludedInstance.length > 0) {
                    let packageNames = nonIncludedInstance.map(it => getPackageName(it.tvPackage)).join(", ")
                    let packageNamesArray = packageNames.split(', ');
                    packageNames = packageNamesArray.filter((item, index) => packageNamesArray.indexOf(item) === index);
                    return <TvChannelListPackage packageName={packageNames.join(", ")}/>
                } else return <X/>
            }
        }
        return <X/>;
    }

    function calculateChannelColSize(columnCount) {
        const baseColSize = Math.floor(12 / columnCount);
        let colSizes = tariffModels.map(tm => baseColSize);
        colSizes.push(baseColSize);

        let reminder = 12 % columnCount;
        for(let i = 0; reminder !== 0; i++) {
            colSizes[i]++;
            reminder--;
        }

        return colSizes;
    }

    function displayChannelName(channel) {
        if(props.lang === 'en_US')
            return channel.nameEN;
        else if(props.lang === 'sq_AL')
            return channel.nameAL;
        else return channel.name;
    }

    function getPackageName(tvPackage) {
        if(props.lang === 'en_US')
            return tvPackage.nameEN;
        else if(props.lang === 'sq_AL')
            return tvPackage.nameAL;
        else return tvPackage.name;
    }
};

export default tvChannelsList;